export const JSON_ONE6NW = {

    "ag_id": "paygate",
    "me_id":"202205240004",
    "order_no": "1010176361036299506",
    "refund_reason”": " “Test”",
    "ag_ref":"OemvbzX2wZpCBD+AZOvp/3hTF3jx1ejvSOd2VdySbE8="

}